/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import './footer.css'
import {FaInstagram, FaTwitter, FaGithub, FaLinkedin, } from 'react-icons/fa'

const Footer = () => {
  return (
    <footer>
      <a href="#" className='footer_logo'>Desh Deepak Kushwaha </a>
      <ul className='permalinks'>
        <li><a href='#'>Home</a></li>
        <li><a href='#about'>About</a></li>
        <li><a href='#project'>Projects</a></li>
        <li><a href='#experience'>Experience</a></li>
        <li><a href='#services'>Services</a></li>        
        <li><a href='#testimonials'>Testimonials</a></li>
        <li><a href='#contact'>Contact</a></li>
      </ul>
      <div className="footer_socials">
      <a href="https://www.linkedin.com/in/desh-deepak-kushwaha-b65929254/" target="_blank" rel="noreferrer"><FaLinkedin /></a>
          <a href="https://github.com/DeshDeepakKushwaha" target="_blank" rel="noreferrer"><FaGithub /></a>
          <a href="https://twitter.com/deepu4477?t=5PkHBRFDruPI4wtj3mIk7Q&s=08" target="_blank" rel="noreferrer"><FaTwitter /></a>
           <a href="https://www.instagram.com/deepu_4477/?igshid=NTA5ZTk1NTc%3Ds" target="_blank" rel="noreferrer"><FaInstagram /></a>
      </div>
      <div className="footer_copyright">
        <small>&copy; Desh Deepak Kushwaha Portfolio. All rights reserved.</small>
      </div>
    </footer>
  )
}

export default Footer